import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import * as CopyText from '@segment/matcha/recipes/CopyText'
import HeroBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'

import DemoForm from '@segment/templates/Forms/DemoForm'

import heroPng2x from './assets/Hero@2x.png'
import heroWebp from './assets/Hero.webp'
import heroWebp2x from './assets/Hero@2x.webp'

const copy = {
  overline: `Journeys`,
  heading: `Build trust and improve performance`,
  description: `Unlock additional value and engage customers with personalized messages, when they need them and over the channel they prefer.`,
}

const FORM_ID = `journeys-demo-request`

const Hero: FC<PropsWithChildren<unknown>> = () => {
  return (
    <Wrapper>
      <HeroBase variant="2Col">
        <StyledHeroCopy>
          <CopyText.Overline tag="h5" variant="h5">
            {copy.overline}
          </CopyText.Overline>
          <CopyText.Heading variant="h1" tag="h1">
            {copy.heading}
          </CopyText.Heading>
          <CopyText.Description variant="pExtraLarge" tag="p">
            {copy.description}
          </CopyText.Description>
          <HeroRecipe.Form>
            <DemoForm isProgressive={true} customFormIdentifier={FORM_ID} customTrackingType={FORM_ID} />
          </HeroRecipe.Form>
        </StyledHeroCopy>
        <HeroRecipe.Contents>
          <picture>
            <source type="image/webp" srcSet={`${heroWebp}, ${heroWebp2x} 2x`} />
            <HeroRecipe.Image width="533" height="404" src={heroPng2x} alt="" />
          </picture>
        </HeroRecipe.Contents>
      </HeroBase>
    </Wrapper>
  )
}

const Wrapper = styled.header`
  background-color: ${({ theme }) => theme.palette.twilio.green[10]};

  ${({ theme }) => theme.breakpoints.down(`lg`)} {
    padding-top: 0;
  }
`

const StyledHeroCopy = styled(HeroRecipe.Copy)`
  ${({ theme }) => theme.breakpoints.down(`lg`)} {
    text-align: left;
  }
`

export default Hero
